import React from 'react';
import CountryItem from '@opm/pages/Hashtag/components/CountryItem';
import './index.scss';
import BubbleCommon from '@op/components/BubbleCommon';
import { ClassSpecial } from '@op/constants/common';

export interface ICountriesListProps {
  /** List of country codes */
  countries: string[];
  /** Max visible icons before collapsing */
  maxVisible?: number;
  /** Icon size */
  iconSize?: number;
}

/**
 * CountriesList — shows first N country icons, hover bubble for the rest
 * Shared between CardListView and TableView (AdInfoCell).
 */
export default function CountriesList({
  countries,
  maxVisible = 3,
  iconSize = 16,
}: ICountriesListProps) {
  if (!countries || countries.length === 0) return null;

  const visible = countries.slice(0, maxVisible);
  const rest = countries.slice(maxVisible);

  return (
    <div className="dbom-countries-list">
      {visible.map((country: string) => (
        <BubbleCommon
          showIcon={false}
          tipsMap={null}
          key={country}
          placement="top"
          content={
            <CountryItem country={country} iconStyle={{ width: iconSize }} />
          }
        >
          <CountryItem
            country={country}
            iconStyle={{ width: iconSize }}
            showText={false}
          />
        </BubbleCommon>
      ))}
      {rest.length > 0 && (
        <BubbleCommon
          showIcon={false}
          tipsMap={null}
          overlayClassName={ClassSpecial.BUBBLE_SCROLL}
          placement="top"
          content={
            <div
              className={`dbom-countries-list__tooltip ${ClassSpecial.BUBBLE_SCROLL_CONTENT}`}
            >
              {rest.map((country: string) => (
                <div style={{ width: '100%' }} key={country}>
                  <CountryItem
                    country={country}
                    iconStyle={{ width: iconSize }}
                    showText
                  />
                </div>
              ))}
            </div>
          }
        >
          <span className="dbom-countries-list__more">+{rest.length}</span>
        </BubbleCommon>
      )}
    </div>
  );
}
